<template>
    <div class="user-profile-container">
      <!-- 使用一个flex容器包裹所有内容 -->
      <div class="content-wrapper">
        <!-- 用户头像和基本信息 -->
        <div class="profile-header">
          <van-image round width="80px" height="80px" :src="info.circleUrl" class="profile-avatar" />
          <div class="profile-info">
            <div class="contact-info">
              <span class="name">{{ info.username }}</span>
              <span class="phone">{{ info.phone }}</span>
            </div>
          </div>
        </div>

        <div>
          <!-- 用户详细信息 -->
          <van-cell-group border inset>
            <van-cell title="加盟站点" :value="info.jmzd">
              <template slot="icon">
                <van-icon name="shop" size="1.8em" color="#FF1F58"/>
              </template>
            </van-cell>
          </van-cell-group>
        </div>

        <div style="margin: 50px 0px">
          <van-cell-group border inset>
            <van-cell v-for="(item, i) in functionCol" :key="i" :title="item.title" @click.stop="item.func" :is-link="true">
              <template slot="icon">
                <van-icon :name="item.icon" size="1.8em" :color="item.color"/>
              </template>
            </van-cell>
          </van-cell-group>
        </div>

      </div>
      <yq-tabbar :active="1"></yq-tabbar>
    </div>
</template>

<script>
import { userInfo } from '@/api/shopapi';
import yqTabbar from '@/components/yq-tabbar.vue';
export default {
  data() {
    return {
      isLoading: false,
      info: {
        username: '',
        phone: null,
        card: null,
        jmzd: null,
        userCompany: '阿里云',
        circleUrl: "https://img.yzcdn.cn/vant/cat.jpeg"
      },
      functionCol: [
        {
          title: '学习情况', icon: 'play-circle', color: '#0081FD', func: () => {
            this.$router.push({ name: 'studyLog' })
          }
        },
        {
          title: '考试情况', icon: 'records', color: '#FF9000', func: () => {
            this.$router.push({ name: 'examLog' })
          }
        }
      ]
    };
  },
  components: {
    yqTabbar
  },
  created() {
    this.info = Object.assign(this.info, JSON.parse(localStorage.getItem('info')) || { username: '用户姓名', phone: ' ' })
  },
  methods: {
    logout() {
      // 清除用户的登录状态, 比如从localStorage中移除token
      localStorage.removeItem('userToken');

      // 重定向到登录页面或其他页面
      this.$router.push({ name: 'Login' }); // 假设你的登录页面名为 'Login'

      // 提示用户登出成功
      this.$toast.success('登出成功');
    },
    onRefresh() {
      userInfo().then(res => {
        localStorage.setItem('info', JSON.stringify(res.data))
        Object.assign(this.info, res.data)
        this.$toast('刷新成功');
        this.isLoading = false;
      })
    }
  }
};
</script>

<style scoped>
.user-profile-container {
  padding-top: 40px;
  background-color: #F0EFF5;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 96px);
  /* 确保页面最小高度为视窗高度 */
}

.content-wrapper {
  flex-grow: 1;
  /* 让内容区域尽可能扩展 */
  overflow-y: auto;
  /* 如果内容超出，则允许滚动 */
}

.profile-header {
  text-align: center;
  /* 使头像居中 */
  margin-bottom: 0px;
  /* background-color: #fff; */
}

.profile-avatar {
  margin: 0 auto;
  /* 确保头像水平居中 */
  display: block;
}

.profile-info {
  margin-bottom: 20px;
  margin-top: 10px;
  padding-bottom: 10px;
}

.contact-info {
  display: inline-block;
  text-align: left;
}

.name {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 10px;
  /* 名字和电话之间留点空间 */
}

.phone {
  font-size: 14px;
  color: #666;
  display: inline-block;
}

.logout-container {
  width: 100%;
  background-color: #fff;
  /* 匹配页面背景色 */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  /* 添加顶部阴影效果 */
  padding: 10px;
  box-sizing: border-box;
}

/* 移除 van-contact-card 左侧图标 */
.custom-contact-card .van-contact-card__icon {
  display: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-info {
    display: block;
    text-align: center;
  }

  .name,
  .phone {
    display: block;
    margin-right: 0;
  }

  .van-cell {
    font-size: 14px;
  }
}

@media (min-width: 769px) {
  .contact-info {
    display: inline-block;
    text-align: left;
  }

  .name,
  .phone {
    display: inline-block;
  }

  .van-cell {
    font-size: 16px;
  }
}
</style>
<style scoped lange='less'>
.van-icon {
  margin-right: 8px;
}
</style>